import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs/Observable";
import { of } from "rxjs/observable/of";
import { AuthenticationService } from "../services/authentication.service";
import { SessionStateService } from "../services/session-state.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private sessionStateService: SessionStateService,
    private readonly cookiesService: CookieService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const url: string = state.url;
    return this.checkLogin(url);
  }

  checkLogin(url: string): Observable<boolean> {
    if (this.authenticationService.isAuthenticated()) {
      return of(true);
    }

    this.cookiesService.set("redirectUrl", url);

    const cognitoUser: any = this.authenticationService.getAuthenticatedUser();
    const rememberMe = this.sessionStateService.getRememberMe();

    if (rememberMe && cognitoUser) {
      return this.authenticationService.getSession().flatMap(() => of(true));
    } else {
      this.authenticationService.logout();
      //this.router.navigate(['/sign-in']);
      return of(false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/guards/auth.guard.ts